import type LoginService from 'shared/login/login.service';
import type WalkerService from 'shared/services/walker.service';
import type RegistrationService from 'shared/login/registration.service';
import type ActionRequestService from 'shared/services/action-request.service';
import {actionRequestMethods} from 'shared/constants/portaro.constants';


export class AuthPairingService {
    public static serviceName = 'authPairingService';
    /*@ngInject*/
    constructor(private loginService: LoginService,
                private walker: WalkerService,
                private registrationService: RegistrationService,
                private actionRequestService: ActionRequestService) {
    }

    public async mergeToAuthenticatedInternalUser(provider: string) {
        await this.actionRequestService.action(`/api/auth/pair-with-current-auth/${provider}`, actionRequestMethods.POST, {});
        return this.walker.newPage('/');
    }

    public async saveNewReader() {
        await this.registrationService.savePersonByForm({}, null);
        return this.walker.newPage('/');
    }

    public async logout() {
        return this.loginService.logout('/');
    }
}